import { useEffect, useState } from 'react';
import { useT } from '../lib/i18n';

interface LoadingScanProps {
  previews: string[];
}

export function LoadingScan({ previews }: LoadingScanProps) {
  const t = useT();
  const stages = [t('scan.parsing.reading'), t('scan.parsing.translating'), t('scan.parsing.almost')];
  const [stage, setStage] = useState(0);
  const [elapsed, setElapsed] = useState(0);

  useEffect(() => {
    const id = setInterval(() => {
      setStage((s) => Math.min(s + 1, stages.length - 1));
    }, 6000);
    return () => clearInterval(id);
  }, [stages.length]);

  useEffect(() => {
    const start = Date.now();
    const id = setInterval(() => setElapsed(Math.floor((Date.now() - start) / 1000)), 1000);
    return () => clearInterval(id);
  }, []);

  const primary = previews[0];
  const slow = elapsed > 25;

  return (
    <div className="min-h-dvh flex flex-col safe-top safe-bottom container-app">
      <div className="flex-1 flex flex-col items-center justify-center gap-8 pt-8">
        {primary && (
          <div
            className="relative rounded-md overflow-hidden"
            style={{ width: '100%', maxWidth: 320, background: 'var(--color-surface)' }}
          >
            <img src={primary} alt="Captured menu" style={{ width: '100%', display: 'block', maxHeight: 380, objectFit: 'contain', filter: 'saturate(0.85)' }} />
            <div className="scanner-sweep" aria-hidden="true" />
          </div>
        )}

        <div className="text-center px-6" style={{ minHeight: 72 }}>
          <p style={{ fontSize: 16, fontWeight: 500 }}>{stages[stage]}</p>
          <p className="text-sm pt-2" style={{ color: 'var(--color-text-secondary)' }}>
            {slow
              ? `Dense menus can take up to a minute. Hang on… (${elapsed}s)`
              : `This usually takes 10\u201330 seconds. (${elapsed}s)`}
          </p>
        </div>
      </div>

      <style>{`
        @keyframes scanSweep {
          0% { transform: translateY(-10%); opacity: 0; }
          15% { opacity: 0.6; }
          85% { opacity: 0.6; }
          100% { transform: translateY(110%); opacity: 0; }
        }
        @media (prefers-reduced-motion: no-preference) {
          .scanner-sweep {
            position: absolute;
            inset: 0;
            background: linear-gradient(180deg, transparent 30%, rgba(232, 93, 44, 0.35) 50%, transparent 70%);
            animation: scanSweep 2.4s ease-in-out infinite;
            pointer-events: none;
          }
        }
        @media (prefers-reduced-motion: reduce) {
          .scanner-sweep {
            position: absolute;
            inset: 0;
            background: rgba(232, 93, 44, 0.12);
            pointer-events: none;
          }
        }
      `}</style>
    </div>
  );
}
